import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeoMetadata, getSeoMetadata } from 'utils/seo';

function SeoMetadata() {
  const { pathname } = useLocation();

  useEffect(() => {
    applySeoMetadata(getSeoMetadata(pathname));
  }, [pathname]);

  return null;
}

export default SeoMetadata;
